// extracted by mini-css-extract-plugin
export var textInput = "_co-0";